module.exports = "/virtual-football/img/video/clubs/england/liverpool.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/england/liverpool.png
// module id = 286
// module chunks = 6